export default function initTimezoneHandler() {
    document.addEventListener("alpine:init", () => {
        Alpine.data("localMatchTime", (utcDate) => ({
            formatted: "",

            init() {
                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const date = new Date(utcDate);

                // Follow the page locale (<html lang>) so the match time is
                // rendered in the user's language, not hardcoded Hungarian.
                const locale = document.documentElement.lang || "hu-HU";

                this.formatted = new Intl.DateTimeFormat(locale, {
                    timeZone: timezone,
                    month: "long",
                    day: "numeric",
                    weekday: "long",
                    hour: "2-digit",
                    minute: "2-digit",
                }).format(date);

                if (document.cookie.indexOf("user_timezone=") === -1) {
                    document.cookie = `user_timezone=${timezone}; path=/; max-age=${60 * 60 * 24 * 365}`;
                }
            },
        }));
    });
}
